<div class="compare-dialog" *ngIf="visible">
    <div class="compare-dialog__header" *ngIf="!minimized">
        <h3>{{'compareDialog.title' | content}}</h3><mat-icon (click)="toggleDialog()" data-cy="minimizeDialog" >minimize</mat-icon>
    </div>
    <div class="compare-dialog__content" *ngIf="!minimized">
        <div class="compare-dialog__data-container" *ngFor="let itemToCompare of itemsToCompare; let i = index;">
            <p class="animated wiggle">
                {{itemToCompare.naam}}
            </p>
            <mat-icon (click)="removeItem(itemsToCompare[i])" data-cy="verwijderFunctie">highlight_off</mat-icon>
            <hr/>
        </div>
        <p *ngIf="itemsToCompare.length !== 2">{{'compareDialog.error' | content}}</p>
        <button [disabled]="itemsToCompare.length !== 2" routerLink="/compare" class="compare-dialog__button">
            {{'compareDialog.start' | content}}
        </button>
    </div>
  <div class="compare-dialog__header" *ngIf="minimized">
    <h3>{{'compareDialog.title' | content}}</h3><mat-icon (click)="toggleDialog()" data-cy="minimizeDialog" >minimize</mat-icon>
  </div>
</div>
